import { loadApplications, loadMcpServers } from '../api/applications';
import { ResourceType as AiResourceType } from '../types/ai-apps';
import { useResourcesStore } from 'vince-core/stores/resourcesStore';
import { Action } from 'vince-core/types/roles';
import { ResourceType, type ResourceItem } from 'vince-core/types/common';

export default defineNuxtPlugin(() => {
    const store = useResourcesStore();
    store.registerResource(AiResourceType.MCP_SERVER.toString(), 'ai-apps.mcpServersMenu', [Action.WRITE, Action.READ], async () => {
        return await loadMcpServers().then((servers) => {
            return servers.map((it) => {
                return {
                    id: it.id,
                    key: it.id,
                    label: it.name,
                    description: it.systemPrompt,
                    resourceType: AiResourceType.MCP_SERVER.toString(),
                    usable: true,
                    labels: []
                } as ResourceItem;
            });
        });
    }, 'pi pi-server');

    store.registerResource('AI_APP', 'addon.app.aiApps', [Action.WRITE, Action.READ], async () => {
        const applications = await loadApplications({ sort: 'name' });
        return applications.map(it => ({
            id: it.id,
            key: it.id,
            label: it.name,
            resourceType: 'AI_APP',
            usable: true
        }));
    }, undefined, [ResourceType.APP]);
});
